export default {
  read: {
    title: "Datos",
    subtitle: "Datos y estadísticas",
    income: "Ingresos",
    totalIncome: "Ingresos totales",
    incomeOverTime: "Ingresos en el tiempo",
    createdProjects: "proyectos creados",
    newEvents: "eventos totales",
    services: "servicios ofrecidos",
    reviews: "reseñas obtenidas",
    bookings: "reservas generadas",
    articles: "articulos publicados",
    collected: "Recaudado este mes",
    currentCollected: "recaudados - 5% de Lazzaro",
    withdraw: "Retirar dinero recaudado",
    totalDonors: "Nº de donantes",
    analyticsLink: "Link Google Analytics",
    labels: {
      projects: "Proyectos",
      events: "Eventos",
      services: "Servicios",
      shop: "Tienda"
    }
  }
};
